import React from 'react';

import { Box, createStyles, useMantineTheme } from '@mantine/core';
import { MarkdownRenderer } from 'components/ExtractedContent/ExtractedContentPreview/MarkdownRenderer';
import { getMarkdownStyles } from 'components/ExtractedContent/markdownStyles';

interface ContentSectionProps {
  content: string;
}

const useStyles = createStyles((theme) => ({
  contentSection: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    padding: '16px',
    overflow: 'hidden'
  },
  contentBackground: {
    flex: 1,
    borderRadius: theme.radius.lg,
    background: theme.colors.gray[0],
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden'
  },
  scrollContainer: {
    flex: 1,
    overflowY: 'auto',
    overflowX: 'hidden',
    padding: '16px 28px',
    scrollbarColor: `${theme.colors.gray[4]} transparent`
  }
}));

export function ContentSection({ content }: ContentSectionProps) {
  const theme = useMantineTheme();
  const { classes } = useStyles();
  const markdownStyles = getMarkdownStyles(theme);

  return (
    <Box className={classes.contentSection}>
      <Box className={classes.contentBackground}>
        <Box className={classes.scrollContainer} sx={markdownStyles}>
          <MarkdownRenderer content={content} />
        </Box>
      </Box>
    </Box>
  );
}
